module.exports = __webpack_public_path__ + "img/lesotho.38bb244f.svg";